/**
 * Created by Administrator on 2017/3/17.
 */
//import { ApiType } from '../config/api-type'
//const HOST=location.hostname=='localhost'?'http://172.16.100.243:8080/naturallyplus/cms':location.protocol+'//'+location.hostname+':8800/naturallyplus/cms';
// const HOST = 'http://azjavaq.mtel.ws:8080/naturallyplus/cms';
/*生产环境*/
//const HOST='http://api.naturally-plus.com.tw/naturallyplus/cms';
/*prod*/
//const HOST='http://54.168.209.245/naturallyplus/cms';
//const HOST='http://gbl-tomcat-1875963771.ap-northeast-1.elb.amazonaws.com/naturallyplus/cms';

import { environment } from "../../environments/environment";

const HOST = environment.base_url;

export const API = {
  login: HOST + "/login",
  uploadImg: HOST + "/upload",
  resourcePath: HOST + "/upload/serverUrl",
  banner: HOST + "/banner",
  newsCategory: HOST + "/news/category",
  getTemp: HOST + "/upload/view?fileName=",
  news: HOST + "/news",
  activeNewsCategory: HOST + "/news/activeCategory",
  aboutUsCategory: HOST + "/aboutUs/category",
  aboutUs: HOST + "/aboutUs",
  sendAboutUsNotifyPushAll: HOST + "/aboutUs/sendAboutUsNotifyPush/all",
  sendAboutUsNotifyPush: HOST + "/aboutUs/sendAboutUsNotifyPush",

  activeAboutUsCategory: HOST + "/aboutUs/activeCategory",
  account: HOST + "/account",
  roles: HOST + "/account/roles",
  productBanner: HOST + "/productBanner",
  settingContent: HOST + "/settingContent",
  shareContent: HOST + "/share",
  share: HOST + "/inviting_switch",
  shareUpdate: HOST + "/inviting_switch/update",
  product: HOST + "/product",
  productGenre: HOST + "/product/genre",
  notice: HOST + "/notice",
  noticeList: HOST + "/notice/list",
  systemSetting: HOST + "/systemSetting",
  customerType: HOST + "/aboutUs/getCustomerType",
  newsCustomerType: HOST + "/news/getCustomerType",
  trackingNumber: HOST + "/trackingNumber",
  aboutAddress: HOST + "/aboutUs/address",
  sign_in: HOST + "/badge/sign_in",
  sign_in_createOrUpdate: HOST + "/badge/sign_in/update",
  sign_in_product: HOST + "/badge/sign_in/product",
  sign_in_select: HOST + "/badge/sign_in/select",
  sign_in_product_createOrUpdate:
    HOST + "/badge/sign_in/product/createOrUpdate",
  challenge_push: HOST + "/badge/challenge/push",
  giftBadge: HOST + "/gift/badge",
  giftCreateOrUpdate: HOST + "/gift/badge/createOrUpdate",
  giftMember: HOST + "/gift/member",
  notificationMessage: HOST + "/notificationMessage",
  sendNewsNotifyPushAll: HOST + "/news/sendNewsNotifyPush/all",
  sendNewsNotifyPush: HOST + "/news/sendNewsNotifyPush",
  sendCategoryNotifyPushAll: HOST + "/news/sendCategoryNotifyPush/all",
  sendCategoryNotifyPush: HOST + "/news/sendCategoryNotifyPush",
  giftStatus: HOST + "/gift/giftStatus",
  giftTimeType: HOST + "/gift/giftTimeType",
  notifyType: HOST + "/notificationMessage/notifyType",
  notifyStatus: HOST + "/notificationMessage/notifyStatus",
  deductFail: HOST + "/notificationMessage/deductFail",
  deductFail_update: HOST + "/notificationMessage/deductFail/update",
  systemSetting_version: HOST + "/systemSetting/version",
  systemSetting_version_detail: HOST + "/systemSetting/version/detail",
  systemSetting_version_update: HOST + "/systemSetting/version/update",
  message: HOST + "/message",
  messagePushAll: HOST + "/message/push/all",
  informmessagePushAll: HOST + "/latestNoticeAndDiscounts/push/all",
  messagePush: HOST + "/message/push",
  informmessagePush: HOST + "/latestNoticeAndDiscounts/push",
  messageDelete: HOST + "/message/delete",
  messageDetail: HOST + "/message/detail",
  messageCreateOrUpdate: HOST + "/message/createOrUpdate",
  signIn_history: HOST + "/badge/sign_in/history",
  signIn_history_detail: HOST + "/badge/sign_in/history/detail",
  banner_regionType: HOST + "/banner/regionType",
  fanstv: HOST + "/fanstv",
  film: HOST + "/film",
  filmType: HOST + "/filmType",
  contractPlan: HOST + "/fanstv/contractPlan",
  catetorySort: HOST + "/filmType/catetorySort",
  supplement: HOST + "/supplement",
  parameter: HOST + "/parameter",
  parameterUpdate: HOST + "/parameter/update",
  challengePushType: HOST + "/badge/challenge/push/BADGE_SWITCH",
  experienceTask: HOST + "/experienceTask",
  experienceTaskPage: HOST + "/experienceTask/page",
  course: HOST + "/course",
  courseType: HOST + "/course/type",
  courseTypeList: HOST + "/course/courseType",
  appManager: HOST + "/appManager",
  enrollRecord: HOST + "/course/enrollRecord",
  enrollRecordDetail: HOST + "/course/enroll/detail/",
  goalList: HOST + "/goal",
  goalUpdate: HOST + "/goal/createOrUpdate",
  goalTask: HOST + "/goaltask",
  goalTaskList: HOST + "/goaltask/page",
  goalTaskEdit: HOST + "/goaltask/createOrUpdate",
  goalRealtion: HOST + "/goaltask/goalTaskList/",
  goalRealtionUpdate: HOST + "/goaltask/addOrUpdateRelation",
  goalParameter: HOST + "/goalParameter",
  latestActivityList: HOST + "/latestActivity/page",
  latestActivityEdit: HOST + "/latestActivity/createOrUpdate",
  latestActivity: HOST + "/latestActivity",
  getProfessions: HOST + "/news/profession",
  courseImport: HOST + "/course/import",
  experienceParamsList: HOST + "/experienceParameter/page",
  experienceParams: HOST + "/experienceParameter",
  memberDocument: HOST + "/memberDocument",
  memberDocumentResend: HOST + "/memberDocument/resend",
  productSort: HOST + "/product/sort",
  activitySort: HOST + "/latestActivity/sort",
  courseDeleteAll: HOST + "/course/deleteAll",
  deletedAccountList: HOST + "/appAccount/deleteList",
  recoveryAccount: HOST + "/appAccount/updateStatus/",
  question: HOST + "/question",
  useMethod: HOST + "/nselection/useMethod",
  shareProductPage: HOST + "/shareProduct/page",
  shareProduct: HOST + "/shareProduct",
  exportCourses: HOST + "/course/export",

  postFiveGoalTask: HOST + "/fiveGoalTask/createOrUpdateFiveGoalTask",

  getFiveGoal: HOST + "/fiveGoalTask",
  getFiveGoalList: HOST + "/fiveGoalTask/list",

  deleteFiveGoalTask: HOST + "/fiveGoalTask/delete",

  getGoalTypeList: HOST + "/fiveGoalTask/goalTypeList",
  postAttendActivities: HOST + "/fiveGoalTask/createOrUpdateAttendActivities",
  postGoalDream: HOST + "/fiveGoalTask/createOrUpdateGoalDream",
  postGoalTarget: HOST + "/fiveGoalTask/createOrUpdateGoalTarget",
  postInvitation: HOST + "/fiveGoalTask/createOrUpdateInvitation",
  postRosters: HOST + "/fiveGoalTask/createOrUpdateRosters",

  getAttendActivities: HOST + "/fiveGoalTask/activities",
  getGoalDream: HOST + "/fiveGoalTask/goalDream",
  getGoalTarget: HOST + "/fiveGoalTask/goalTarget",
  getInvitation: HOST + "/fiveGoalTask/invitation",
  getRosters: HOST + "/fiveGoalTask/rosters",

  getLatestActivityType: HOST + "/latestActivity/type",
  noticeAndDiscounts: HOST + "/latestNoticeAndDiscounts",
  getNoticeAndDiscountsDetail: HOST + "/latestNoticeAndDiscounts/detail",
  getNoticeAndDiscountsDetailType: HOST + "/latestNoticeAndDiscounts/type",
  exportFiveGoal: HOST + "/five-goal-export/export",
  getFiveGoalTemplate: HOST + "/five-goal-export/exportTemplate",
  uploadFiveGoalTemplate:
    HOST + "/five-goal-export/uploadSupplementarRegistrationData",
};



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/config/api-config.ts